export interface PublicSubledgerAccountDTO {
    AnalyticalBalance: number,
    AccountType: number,
    AccountNumber: string,
    CurrencyCode: string,
    Description: string,
    Nature: number,
    OpeningBalance: number,
    OpeningBalanceInBookKeepingCurrency: number,
    PreviousYearClosingBalance: number,
    PreviousYearClosingBalanceInBookKeepingCurrency: number,
    EntryLines: Array<string>,
    AnalyticalBreakdown: number,
    InputTaxType: number,
    AccountAnalyticalBreakdownPreset: Array<string>,
    ThirdPartiesProfitLossAccounts: Array<string>,
    FiscalYearID: string,
    ID: string
  }